<template>
  <van-cell-group class="mt10">
    <van-cell :title="item.name" is-link to="/material/index" value="新增物料或产品" v-for="(item,i) in searchTypeList" :key="i"/>
  </van-cell-group>
</template>

<script>
  export default {
    data() {
      return {
        searchTypeList: [{
          name: '资产名称设置'
        }, {
          name: '材料名称设置'
        }, {
          name: '生产的商品名称设置'
        }],
      }
    },
    methods: {}
  }
</script>
